<template>
  <div class="affliate-item" v-if="(isFetchedTotalAmount && calculatedAppliableWalletPrice > 0) || appliedAmount">
    <!-- Başlık ve Ok Simgesi -->
    <div
      class="affiliate-collapse-field arrow-main-field"
      data-toggle="collapse"
      href="#collapseExample"
      role="button"
      aria-expanded="false"
      aria-controls="collapseExample"
    >
      <div class="collapse-content">
        <span>{{ $t('affiliate.Use Reference Credit') }}</span>
      </div>
      <div class="icon-wrapper">
        <i class="fa fa-angle-down arrow-icon" />
      </div>
    </div>

    <!-- Form ve Bilgilendirme Alanları -->
    <div :id="'collapseExample'" class="collapse">
      <div class="affiliate-form">
        <!-- Girdi ve Uygula Butonu Satırı -->
        <div class="affiliate-form-row">
          <VMoneyInput
            v-model="amount"
            :name="'affiliateInput'"
            :placeholder="$t('affiliate.placeholder')"
            :disabled="appliedAmount ? true : false"
            :label="inputLabel || null"
            :icon="appliedAmount ? '/img/check-circle.svg' : null"
            :icon-position="'right'"
            :rules="'min_value:0|max_value:' + calculatedAppliableWalletPrice"
            :prefix="currentWallet.currency_symbol || ' '"
          />
          <div class="button-container">
            <button v-if="!appliedAmount" @click.prevent="setAppliedAmount" class="form-button apply">
              {{ $t('Uygula') }}
            </button>
            <button v-else class="form-button remove" @click.prevent="removeAppliedAmount">
              {{ $t('Kaldır') }}
            </button>
          </div>
        </div>

        <!-- Bilgilendirme Kartları -->
        <div class="affiliate-grid">
          <!-- Kullanılabilir Kredi Kartı -->
          <div class="affiliate-info">
            <div class="info-header">
              <span class="info-text">{{ $t('affiliate.Available Reference Credits') }}</span>
              <div v-tippy="{ content: $t('affiliate.tooltipTextAvailable') }" class="tooltip-icon">
                <img src="/img/info.svg" alt="" class="icon" />
              </div>
            </div>
            <div class="info-content">
              <img width="16" src="/img/coin.svg" alt="" class="content-icon" />
              <span class="content-text">
                {{ formatPrice(calculatedAppliableWalletPrice, currentWallet.currency_symbol) }}
              </span>
              <button class="apply-all-button" @click.prevent="applyAllAmount">
                {{ $t('Tamamını Kullan') }}
              </button>
            </div>
          </div>

          <!-- Toplam Kredi Kartı -->
          <div class="affiliate-info">
            <div class="info-header">
              <span class="info-text">{{ $t('affiliate.Total Reference Credits') }}</span>
              <div v-tippy="{ content: $t('affiliate.tooltipTextAvailable') }" class="tooltip-icon">
                <img src="/img/info.svg" alt="" class="icon" />
              </div>
            </div>
            <div class="info-content opacity-30">
              <img width="16" src="/img/coin.svg" alt="" class="content-icon" />
              <span class="content-text">
                {{ formatPrice(currentWallet.balance, currentWallet.currency_symbol) }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <slot name="bottomText" />
    </div>
    <hr class="my-3" />
  </div>
</template>

<script>
export default {
  name: 'Promotion',
  props: {
    customCall: {
      type: Boolean,
      required: false,
    },
    id: {
      type: String,
      required: false,
    },
    currency: {
      type: String,
      required: false,
    },
    inputLabel: {
      type: String,
      required: false,
    },
    products: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      amount: 0,
      isFetchedTotalAmount: false,
      appliedAmount: 0,
      currentWallet: {},
      isLoading: false,
    };
  },
  computed: {
    calculatedAppliableWalletPrice() {
      if (this.appliableWalletPrice || (this.currentWallet && this.currentWallet.id)) {
        const appliableWalletPrice = this.appliableWalletPrice ? this.appliableWalletPrice : 0;
        const currentWalletBalance = this.currentWallet.balance ? this.currentWallet.balance : 0;

        const minPrice = Math.min(appliableWalletPrice, currentWalletBalance);
        if (minPrice > 0) {
          if (this.totalPrice - minPrice < 1) {
            return this.totalPrice - 1;
          }
          return minPrice;
        }
      }
      return 0;
    },
    totalPrice() {
      let finalPrice = 0;

      if (this.products && this.products.length) {
        finalPrice = this.products.reduce((total, price) => total + (price.final_price ? price.final_price : 0), 0);
      }
      return finalPrice;
    },
    appliableWalletPrice() {
      let finalPrice = 0;

      if (this.products && this.products.length) {
        finalPrice = this.products.reduce(
          (total, price) => total + (price.useable_wallet_amount ? price.useable_wallet_amount : 0),
          0
        );
      }
      return finalPrice;
    },
  },
  created() {
    this.getTotalWalletAmount();
  },

  methods: {
    resetAmount() {
      this.appliedAmount = 0;
      this.$emit('set-appliable-amount', 0);
      this.amount = 0;
    },
    applyAllAmount() {
      if (!this.appliedAmount) {
        this.amount = this.calculatedAppliableWalletPrice;
      }
    },
    removeAppliedAmount() {
      this.appliedAmount = 0;
      this.$emit('set-appliable-amount', 0);
    },
    setAppliedAmount() {
      if (this.amount > this.calculatedAppliableWalletPrice || this.amount < 0) {
        this.$toasted.error(this.$t('Lütfen geçerli bir fiyat girin'));
        return;
      }

      this.appliedAmount = this.amount;
      this.$emit('set-appliable-amount', this.amount);
    },
    getTotalWalletAmount() {
      this.isLoading = true;

      $axios
        .get('wallet/default')
        .then((s) => {
          if (s.data && s.data.data) {
            this.currentWallet = s.data.data;
          } else {
            this.currentWallet = {
              id: null,
              currency: null,
              currency_symbol: null,
              balance: 0,
            };
          }
        })
        .finally((s) => {
          this.isLoading = false;
        });

      this.isFetchedTotalAmount = true;
    },
  },
};
</script>

<style scoped lang="less">
.arrow-main-field {
  .arrow-icon {
    transition: transform 150ms ease-in-out;

    &.arrow-icon-md {
      font-size: 1.125rem; // text-lg
    }

    &.arrow-icon-sm {
      font-size: 0.875rem; // text-sm
    }
  }
  &[aria-expanded='true'] {
    .arrow-icon {
      transform: rotate(180deg);
    }
  }
}

.affliate-item {
  display: flex;
  flex-direction: column;

  .affiliate-collapse-field {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    user-select: none;

    &:focus {
      outline: none;
    }

    .collapse-content {
      display: flex;
      align-items: center;
      flex: 1;

      span {
        font-size: 0.875rem;
        font-weight: 500;
        line-height: 1.5;
        letter-spacing: -0.01em;
      }
    }

    .icon-wrapper {
      display: flex;
      align-items: center;
      margin-left: 1rem;

      i {
        font-size: 1rem;
      }
    }
  }

  .affiliate-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;

    .affiliate-form-row {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      flex-wrap: nowrap;

      @media (min-width: 768px) {
        flex-direction: row;
      }
    }

    .form-button {
      height: 3rem;
      border-radius: 0.375rem;
      padding: 0.75rem 1rem;
      font-size: 1rem;
      font-weight: 500;
      transition: all 0.15s ease-in-out;
      cursor: pointer;
      width: auto;

      @media (max-width: 768px) {
        width: 100%;
      }

      &.apply {
        background-color: #fff;
        border: 1px solid #ccc;
        color: #000;
      }

      &.remove {
        background-color: #e53e3e;
        border: 1px solid transparent;
        color: #fff;
      }
    }
  }

  .affiliate-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.625rem;
    margin-top: 0.5rem;
    @media (max-width: 576px) {
      grid-template-columns: repeat(1, 1fr);
    }

    .affiliate-info {
      border: 1px solid #ccc;
      border-radius: 0.375rem;
      padding: 0.5rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .info-header {
        display: flex;
        justify-content: space-between;

        .info-text {
          font-size: 0.875rem;
          font-weight: 500;
          line-height: 1.5;
        }

        .tooltip-icon {
          border-radius: 0.375rem;

          margin-left: 0.25rem;

          .icon {
            font-size: 1.25rem;
            width: 20px;
            height: 20px;
          }
        }
      }

      .info-content {
        display: flex;
        gap: 0.25rem;
        align-items: center;
        padding: 0.375rem 0.5rem;
        border: 1px solid #ccc;
        border-radius: 0.375rem;
        margin-top: 0.25rem;
        height: 2.5rem;

        .content-icon {
          font-size: 1rem;
          margin-right: 0.25rem;
        }

        .content-text {
          flex: 1;
          font-size: 0.875rem;
          font-weight: 600;
        }

        .apply-all-button {
          font-size: 0.75rem;
          font-weight: 500;
          padding: 0.25rem 0.5rem;
          border: 1px solid #ccc;
          border-radius: 0.375rem;
          margin-left: 0.25rem;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
